<template>
  <div id="main">

    <div class="swiper-container">
      <swiper v-if="items.length"  :options="swiperOptions" ref="mySwiper">
      <swiper-slide class="slide" v-for="item in items">

        <img v-if="item.type == 'image'" :src="item.src" class="fullscreen-image" :style="`filter: blur(${item.blur}px);`"/>

        <video v-if="item.type == 'video'" autoplay loop muted class="fullscreen-video" :style="`filter: blur(${item.blur}px);`">
          <source :src="item.src" type="video/mp4">
        </video>

      </swiper-slide>

      <!-- ... 추가 이미지 및 동영상 슬라이드 -->
    </swiper>

    </div>

    <div class="home-container overlay">
      <header>
          <div class="logo">
            <a href="javascript:;" @click="goTo">
              <img :src="require('@/assets/images/ewide-logo.png')" class="rms-logo"/>
            </a>
<!-- 
          <span class="divider">|</span>
          <img src="/static/commons/images/main_logo.png" class="emart" />
           -->
          </div>
          <nav>
              <a v-if="isLogin" href="javascript:;" @click="goMain"><i class="el-icon-house" ></i> Main</a>

              <a v-if="!isLogin" href="javascript:;" @click="showLogin=true;showOverlay=true"><i class="el-icon-user-solid"></i> 로그인</a>
              <a v-if="isLogin" href="javascript:;" @click="logout"><i class="fa fa-sign-out-alt" ></i> 로그아웃</a>
              <span v-if="!isLogin" class="divider ml-4">|</span>
              <a v-if="!isLogin" href="#" @click="goJoin" class="ml-3">회원가입</a>
              <a v-if="!isLogin" href="#" @click="findId">아이디 찾기</a>
              <a v-if="!isLogin" href="#" @click="findPwd">비밀번호 초기화</a>
              <a v-if="!isLogin" href="#" @click="$router.push('/home/board/list/1')">Q&amp;A 남기기</a>
          </nav>
      </header>
      <main>
      </main>
      <footer>
          <div class="contact">
            <div @click.stop="$router.push('/home/board/list/1')" class="guide-btn"><a>Q&amp;A 남기기</a></div>
            <div class="promo-ask-wrap">
              <img :src="require('@/assets/images/promo-ask.png')" class="promo-ask"/>
            </div>
            <div class="comp-tel" v-html="wideColor.tel"></div>
            <!-- <div v-html="wideColor.info"></div> -->
          </div>
          <div class="guide">
            <div class="rms">
              <a href="http://www.retailmedia.co.kr" target="_blank"><img :src="require('@/assets/images/rms-title.png')" class="rms-title"/></a>
            </div>
            <div @click.stop="goMediaInfo" class="guide-btn"><a>매체 소개</a></div>
          </div>
      </footer>
    </div>


    <div v-if="showOverlay" class="home-container overlay login" :class="{'app' :  !showLogin && grayBg}">
      <header>
        <div class="logo">
          <img :src="require('@/assets/images/ewide-logo.png')" class="rms-logo"/>
        </div>
          <nav>
              <a href="javascript:;" @click="close"><i class="el-icon-close close-btn" ></i></a>
          </nav>
      </header>
      <div v-if="!showLogin" class="container">
        <slot></slot>
      </div>

      <main v-if="showLogin" class="login-form">
          <form @submit.prevent="validate(form)" v-if="!isLogin">
            <h1>SIGN UP</h1>
            <div>
              <el-input placeholder="ID" v-model="form.userId"></el-input>
            </div>
            <div class="mt-2">
              <el-input placeholder="PW" v-model="form.password_plain" show-password></el-input>
            </div>
            <div class="mt-2">
              <el-button class="login-btn" type="primary" native-type="submit">
              <span>LOG IN</span>
              <i class="el-icon-caret-right"></i>
              </el-button>
            </div>
            <div class="tool">
              <div>
                <div><a v-if="!isLogin" href="#" @click="goJoin">회원가입</a></div>
                <div><a v-if="!isLogin" href="#" @click="findId">아이디 찾기</a></div>
              </div>
              <div class="mt-3">
                <div><a v-if="!isLogin" href="#" @click="findPwd">비밀번호 초기화</a></div>
                <div><a v-if="!isLogin" href="#" @click="$router.push('/home/board/list/1')">Q&amp;A 남기기</a></div>
              </div>
            </div>
          </form>
      </main>
      <footer>
        <div class="contact">
            <div @click.stop="$router.push('/home/board/list/1')" class="guide-btn"><a>Q&amp;A 남기기</a></div>
            <div class="promo-ask-wrap">
              <img :src="require('@/assets/images/promo-ask2.png')" class="promo-ask"/>
            </div>
            <div class="comp-tel" v-html="wideColor.tel"></div>
            <!-- <div v-html="wideColor.info"></div> -->
          </div>
          <div class="guide">
            <div class="rms">
              <a href="http://www.retailmedia.co.kr" target="_blank"><img :src="require('@/assets/images/rms-title.png')" class="rms-title"/></a>
            </div>
            <div @click.stop="goMediaInfo" class="guide-btn"><a>매체 소개</a></div>
          </div>
      </footer>
    </div>

    
    <div v-show="items.length > 1" class="swiper-button-next"></div>
    <div v-show="items.length > 1" class="swiper-button-prev"></div>      
    <!-- 타원으로 된 네비게이터 -->
    <div v-show="items.length > 1" class="swiper-pagination"></div>

</div>  
</template>
<script>
  import Vue from 'vue'
  
  //import VueAwesomeSwiper from 'vue-awesome-swiper';
  //import 'swiper/dist/css/swiper.css';
  
  import {Card, Checkbox} from 'src/components/UIComponents';
  import {Row, Col, Input, Button} from 'element-ui'
  import MainInfoProxy from "@/proxies/MainInfoProxy";
  import MainImageProxy from '@/proxies/MainImageProxy';
  import UserProxy from "@/proxies/UserProxy";
  import * as types from "@/store/modules/account/mutation-types";
  
  //Vue.use(VueAwesomeSwiper);
  //import { swiper, swiperSlide } from 'vue-awesome-swiper'
  //import 'swiper/dist/css/swiper.css'


  Vue.use(Row)
  Vue.use(Col)
  Vue.use(Input)
  Vue.use(Button)

  export default {
    components: {
      Card,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button,
      //swiper: VueAwesomeSwiper.swiper,
      //swiperSlide: VueAwesomeSwiper.swiperSlide   
      //swiper, swiperSlide
    },
    props: {
      isShowOverlay: {
        type: Boolean,
        defalut: false
      },
      grayBg: {
        type: Boolean,
        defalut: false
      }
    },
    created: function () {

      this.$modal.hideAll()

      new UserProxy()
        .me()
        .then((response) => {
          if(response.header.returnCode === "OK") {
            this.isLogin = true;
          } else {
            this.isLogin = false;
          }
        })
        .catch(() => {
        });

        new MainInfoProxy()
        .getMainContactInfo()
        .then(response => {
          this.wideColor = response.item
        })        

      new MainImageProxy()
        .all()
        .then((response) => {
          this.items = [...response.item.items] 
          this.swiperOptions = {
            loop: this.items.length > 1,
            initialSlide: 0,
            spaceBetween: 0,
            centeredSlides: true,
            speed: 600,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            autoplay: {
              delay: parseInt(response.item.delay) * 1000 ,
              disableOnInteraction: false,
            },
            on: {
              init: function() {
                this.slideTo(1, 0);  // 첫 번째 슬라이드로 이동
              }
            },
            pagination: {
              el: '.swiper-pagination', // pagination 요소의 선택자
              type: 'bullets', // 네비게이터의 타입 (bullets, fraction, progressbar 등)
              clickable: true, // 사용자가 네비게이터를 클릭하여 슬라이드를 변경할 수 있도록 설정
            }          

          }
      })              
    },
    methods: {
      goTo() {
        if(this.isLogin) {
          Vue.router.push({
            name: this.$store.state.account.mainUrl,
          });          
        } else {
          Vue.router.push('/home');          
        }
      },
      goMediaInfo() {
        Vue.router.push({
          name: "MediaInfo"
        });
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate(form) {
        if (form.userId === null || form.password_plain === null) {
          alert("아이디와 패스워드를 입력하세요.");
        } else {
          this.$store.dispatch('auth/login', form);
        }
      },
      logout() {
        this.$store.dispatch('auth/logout');
      },
      goMain() {
        Vue.router.push({
          name: this.$store.state.account.mainUrl,
        });
      },
      goJoin() {
        Vue.router.push({
          name: 'Join',
        });
      },
      findId() {
        this.$router.push('/find-id')
      },
      findPwd() {
        this.$router.push('/find-pwd')
      },
      close() {
        if(!this.showLogin) {
          this.$router.push('/home');
          return;
        }
        this.showLogin = false
        this.showOverlay = false
      }
    },
    data() {
      return {
        showLogin: false,
        showOverlay: this.isShowOverlay,
        isLogin: false,
        wideColor: {},
        form: {
          userId: null,
          password: null,
          password_plain: null
        },
        modelValidations: {
          userId: {
            required: true
          },
          password_plain: {
            required: true,
            min: 4
          }
        },
        items: [],
        swiperOptions: null
      }
    },

  }
</script>
<style scoped>
  @font-face {font-family: "Myriad Pro Regular";src: url("/static/commons/font/MYRIADPRO-REGULAR.woff") format("woff");font-weight: normal;}
  /*@font-face {font-family: "NanumGothic";src: url("/static/commons/fonts/NanumGothic-Regular.woff") format("woff");font-weight:normal;}
  @font-face {font-family: "Noto Sans KR";src: url("/static/commons/fonts/notokr-regular.woff") format("woff");font-weight: 400;}*/

  @-webkit-keyframes scroll_icon {0% {bottom: 0;}100% {bottom: 25px;}}
  @keyframes scroll_icon {0% {bottom: 0;}100% {bottom: 25px;}}
  @-webkit-keyframes fadeIn {0% {opacity: 0;-webkit-transform: translateY(-10%);transform: translateY(-10%);}100% {opacity: 1;-webkit-transform: translateY(0);transform: translateY(0);}}
  @keyframes fadeIn {0% {opacity: 0;-webkit-transform: translateY(-10%);transform: translateY(-10%);}100% {opacity: 1;-webkit-transform: translateY(0);transform: translateY(0);}}

  .swiper-container, .swiper-slide {
    width: 100vw;
    height: 100vh;
  }

  .fullscreen-image, .fullscreen-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /*display: flex;
  align-items: center;
  justify-content: center;*/
  overflow-y: auto;  /* 스크롤 활성화 */
  max-height: 100vh; /* 뷰포트 높이로 최대 높이 설정 */
  z-index: 10;
  -ms-overflow-style: none;  /* Internet Explorer와 Edge에서 스크롤바 숨기기 */
  scrollbar-width: none;     /* Firefox에서 스크롤바 숨기기 */
  }

.overlay::-webkit-scrollbar {
  display: none;  /* Chrome, Safari, Opera에서 스크롤바 숨기기 */
}

.swiper-pagination { 
  position: absolute; right: 60px; bottom: 146px;
}

/* 기본 탄환 (흰색 원) 스타일 */
::v-deep .swiper-pagination-bullet {
  position: relative;
  margin: 7px;
  background-color: transparent !important;
  opacity: 0.9;
}

/* 활성화된 탄환 (흰색 원 + 흰 테두리) 스타일 */
::v-deep .swiper-pagination-bullet-active {
    /*border: 2px solid white; /* 테두리 색상 */
    opacity: 0.9;
}

::v-deep .swiper-pagination-bullet:after {
  position: absolute;
  content: '●';
  font-size: 11px;
  color: white;
  top: 0;
  left: 0;
}

::v-deep .swiper-pagination-bullet-active:after {
    content: '◉';
    /*opacity: 0.8;*/
    color: #efbd40;
    font-size: 24px;
    top: -9px;
    left: -5px;
}
.home-container {
    /*font-family: 'Arial', sans-serif;*/
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: linear-gradient(to top, rgb(0 0 0), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) , rgba(0, 0, 0, 0));    
}

header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 60px;
    background-color: white;
    opacity: 0.9;
    
}

header img.ewide { background-color: #071e3f; margin-left: 10px;}
header img.emart { width: 90px; margin-top:-2px;}
header .divider { margin: 0 12px; color: #adabab; font-size: 16px;}

header nav { font-size: 15px; }
header nav a {
    margin-left: 50px;
    text-decoration: none;
    color: black;
    font-size: 1rem;
}

main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

h1, h2, p {
    margin: 10px 0;
}


footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 60px 40px;
    background-color: transparent;
    color: white;
}

.contact, .guide {
    display: flex;
    justify-content: space-between;
}
.contact { align-items: center; font-size: 15px;}
.guide { line-height: 16px; font-size: 11px;}
.contact > div, .guide > div { padding: 15px;}
footer ::v-deep p { padding: 0 !important; margin: 0 !important;}
.ask {
  font-size: 12px;
  margin-top: 0.2rem;
  text-align: center;
  letter-spacing: 3px;
}

.social-icons span {
    margin-left: 20px;
}

.swiper-button-prev, .swiper-button-next {
  filter: grayscale(1);
  opacity: 0.4; 
}

.guide > div {
  background-color: white;
  border-radius: 4px;
  padding: 0px;
  color: black;
  margin-left: 16px;
}
.guide > div.rms { background-color: transparent;}
.rms-title {width: 220px;}

.contact > div.guide-btn,
.guide > div.guide-btn { font-size: 16px; display: flex; align-items: center; padding: 20px; cursor: pointer;
  background-color: white;
    border-radius: 4px;
    color: black;
    font-weight: 600;
}

.contact > div.guide-btn { padding: 16px; }

.promo-ask-wrap { margin-left:19px;}
.comp-tel { padding-left: 8px;}

.rms { display: flex; align-items: center;}
.rms span { margin: 0 10px; }
.rms span img { filter: grayscale(1)}

.overlay.login {
  background: linear-gradient(0, #fff, #fff);
  z-index: 1000;
  opacity: 0.96;
}

.overlay.login.app {
  background-color: #d3d4de;
}  


.overlay.login header {
    opacity: 1;
}
.close-btn {font-size: 50px;
    position: absolute;
    top: 11px;
    color:#626262;
    right: 25px;}
.login-form {
  max-width: 500px;
  margin: 0 auto;
  width: 360px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: center;  
}    
.login-form h1 {
  font-size: 40px;
  font-weight: 600;
}
.login-btn {
  width: 100%;
    text-align: left;
    font-weight: 600;
    font-size: 17px;
    font-family: inherit;
}

.login-btn ::v-deep > span {
  display: flex;
  justify-content: space-between;
}
.tool {
  display: table;
  text-align: center;
  margin-top: 50px;
  width: 100%;
  font-size: 15px;
}

.tool > div {
  display: table-row;
}
.tool > div > div {
    display: table-cell;
    padding: 10px;
    position: relative;
}
.tool > div > div:first-child:after {
  content: '|';
    position: absolute;
    right: 0;
    color: #d9d9d9;
    font-size: 21px;
    top: 0px;

}

.login footer .contact {
  color: #454545;
}

/*.login .guide > div { background-color: #db0016; color: white;}*/
.login div.guide-btn {
  background-color: #d2d2d2;
  color: #454545;
}
.rms span img {
  filter: grayscale(1) invert(1) brightness(10);
}
.tool a { color: #454545}

.rms-logo { width: 180px; }
.promo-ask { width: 74px; }
</style>
